import { useId } from 'react';
import './accordions.css';

const DURATION = 150;

const AccordionRow = ({
  DesignSystemComponents,
  title,
  children,
  index,
  activeIndex,
  setActiveIndex,
  disabled = false,
}) => {
  const { SvgIcon } = DesignSystemComponents;

  const isOpen = activeIndex === index;

  const btnId = useId();
  const panelId = useId();

  const toggle = () => {
    if (disabled) return;
    setActiveIndex(isOpen ? null : index);
  };

  return (
    <div className='w-100'>
      <button
        id={btnId}
        type='button'
        onClick={toggle}
        aria-expanded={isOpen}
        aria-controls={panelId}
        disabled={disabled}
        className={`clickable-section ${disabled ? 'accordion-disabled' : ''}`}
      >
        <div className='d-flex justify-content-between w-100'>
          <div>{title}</div>
          <SvgIcon name={isOpen ? 'chevronUp' : 'chevronDown'} size='20px' />
        </div>
      </button>

      <div
        id={panelId}
        role='region'
        aria-labelledby={btnId}
        aria-hidden={!isOpen}
        style={{
          display: 'grid',
          gridTemplateRows: isOpen ? '1fr' : '0fr',
          transition: `grid-template-rows ${DURATION}ms ease, opacity ${DURATION}ms ease`,
          overflow: 'hidden',
          opacity: isOpen ? 1 : 0,
        }}
      >
        <div style={{ minHeight: 0, paddingTop: isOpen ? 16 : 0 }}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default AccordionRow;
